import React from "react";
import { Loader2 } from "lucide-react";

export const SectionLoading = ({ text = "Loading..." }) => (
  <div className="flex items-center gap-2 text-[#54B0AF] text-sm">
    <Loader2 size={18} className="animate-spin" />
    <span>{text}</span>
  </div>
);

export const SectionError = ({ message = "Failed to load data." }) => (
  <div className="text-sm text-red-600">{message}</div>
);

